// DivaCase Shopify Theme - Product Detail Page Logic (Robust Option Mapping & Multi-Brand Edition)

(function() {
    const product = window.currentProduct;
    const variants = window.currentProductVariants || [];
    
    if (!product || variants.length === 0) return;

    // Helper to generate color slugs
    function toColorSlug(value) {
        return String(value || "")
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }

    // Helper to format currency
    function formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return `${Number(amount).toLocaleString("tr-TR")} TL`;
    }

    // Identify which option index is Brand/Marka, Model/Cihaz and Color/Renk
    // Shopify options are 0-indexed in JS representation (option1, option2, option3)
    const numOptions = product.options.length;
    let brandOptionIndex = -1;
    let modelOptionIndex = -1;
    let colorOptionIndex = -1;

    product.options.forEach((optName, index) => {
        const nameLower = optName.toLowerCase();
        if (nameLower.includes('renk') || nameLower.includes('color') || nameLower.includes('desen') || nameLower.includes('colour') || nameLower.includes('finish')) {
            colorOptionIndex = index;
        } else if (nameLower.includes('model') || nameLower.includes('cihaz') || nameLower.includes('device') || nameLower.includes('telefon') || nameLower.includes('size') || nameLower.includes('beden')) {
            modelOptionIndex = index;
        } else if (nameLower.includes('marka') || nameLower.includes('brand')) {
            brandOptionIndex = index;
        }
    });

    // Fallbacks if not matched
    if (colorOptionIndex === -1 && modelOptionIndex === -1 && brandOptionIndex === -1) {
        if (numOptions >= 2) {
            modelOptionIndex = 0;
            colorOptionIndex = 1;
        } else if (numOptions === 1) {
            modelOptionIndex = 0;
        }
    } else {
        // If we have unmatched options, assign them to missing slots
        const indices = Array.from({ length: numOptions }, (_, i) => i);
        const mappedIndices = [brandOptionIndex, modelOptionIndex, colorOptionIndex];
        
        indices.forEach(idx => {
            if (!mappedIndices.includes(idx)) {
                if (modelOptionIndex === -1) {
                    modelOptionIndex = idx;
                } else if (colorOptionIndex === -1) {
                    const optLower = product.options[idx].toLowerCase();
                    // Do NOT map it to color if it contains brand/marka keywords
                    if (!optLower.includes('marka') && !optLower.includes('brand')) {
                        colorOptionIndex = idx;
                    }
                } else if (brandOptionIndex === -1) {
                    brandOptionIndex = idx;
                }
            }
        });
    }

    const hasBrandOption = brandOptionIndex >= 0;
    const hasModelOption = modelOptionIndex >= 0;
    const hasColorOption = colorOptionIndex >= 0;
    
    const brandPropName = hasBrandOption ? `option${brandOptionIndex + 1}` : null;
    const modelPropName = hasModelOption ? `option${modelOptionIndex + 1}` : null;
    const colorPropName = hasColorOption ? `option${colorOptionIndex + 1}` : null;

    // Collect all unique models and colors from variants
    const allModels = hasModelOption 
        ? [...new Set(variants.map(v => v[modelPropName]).filter(Boolean))]
        : [];

    const allColors = [];
    if (hasColorOption) {
        variants.forEach(v => {
            const colorVal = v[colorPropName];
            if (colorVal && !allColors.some(c => c.name === colorVal)) {
                allColors.push({
                    name: colorVal,
                    slug: toColorSlug(colorVal),
                    image: v.featured_image?.src || null
                });
            }
        });
    }

    // Hide/Show option fields in HTML based on availability
    const brandField = document.querySelector(".form-field-brand");
    const modelField = document.querySelector(".form-field-model");
    const colorField = document.querySelector(".form-field-color");

    if (!hasModelOption) {
        if (brandField) brandField.style.display = "none";
        if (modelField) modelField.style.display = "none";
    }
    if (!hasColorOption) {
        if (colorField) colorField.style.display = "none";
    }

    // Group models by brand
    const brands = {};

    allModels.forEach(model => {
        let detectedBrand = 'Diğer';
        
        if (hasBrandOption) {
            const matchingVar = variants.find(v => v[modelPropName] === model);
            if (matchingVar && matchingVar[brandPropName]) {
                detectedBrand = matchingVar[brandPropName];
            }
        } else {
            detectedBrand = typeof window.detectBrandFromModel === 'function'
                ? window.detectBrandFromModel(model)
                : (model.toLowerCase().includes('iphone') || model.toLowerCase().includes('apple') ? 'Apple' : (model.toLowerCase().includes('samsung') ? 'Samsung' : 'Diğer'));
        }
        
        if (!brands[detectedBrand]) {
            brands[detectedBrand] = [];
        }
        if (!brands[detectedBrand].includes(model)) {
            brands[detectedBrand].push(model);
        }
    });

    // If a brand has no models, clean it up from active brand lists
    const activeBrands = Object.keys(brands).filter(b => brands[b].length > 0);
    
    // UI elements
    const els = {
        price: document.querySelector("[data-product-price]"),
        compare: document.querySelector("[data-product-compare]"),
        colorsContainer: document.querySelector("[data-pdp-colors]"),
        brandsContainer: document.querySelector("[data-pdp-brand-buttons]"),
        modelSelect: document.querySelector("[data-pdp-model-select]"),
        addBtn: document.querySelector("[data-pdp-add]"),
        qtyValue: document.querySelector("[data-pdp-qty-value]"),
        mainImage: document.getElementById("pdp-main-image"),
        deviceSummary: document.querySelector("[data-device-summary]"),
        currentBrand: document.querySelector("[data-current-brand]"),
        currentModel: document.querySelector("[data-current-model]"),
        autoNote: document.querySelector("[data-device-auto-note]"),
        decisionColor: document.querySelector("[data-decision-color]"),
        customNote: document.querySelector("[data-custom-note]"),
        stickyAdd: document.querySelector("[data-sticky-add]"),
        stickyBuy: document.querySelector("[data-sticky-buy]"),
        stickyTitle: document.querySelector("[data-sticky-title]"),
        stickyPrice: document.querySelector("[data-sticky-price]"),
        stickySelection: document.querySelector("[data-sticky-selection]"),
        inventoryTitle: document.querySelector("[data-inventory-title]"),
        inventoryCopy: document.querySelector("[data-inventory-copy]")
    };

    const activeBrandEl = document.querySelector('.simple-brand-pill.active');
    const activeColorEl = document.querySelector('.color-dot.active');

    // State management
    const state = {
        selectedBrand: activeBrandEl ? activeBrandEl.dataset.brandTab : (activeBrands[0] || 'Diğer'),
        selectedModel: els.modelSelect ? els.modelSelect.value : (hasModelOption ? (allModels.length === 1 ? allModels[0] : '') : null),
        selectedColor: activeColorEl ? activeColorEl.dataset.pdpColorName : (hasColorOption ? (allColors[0]?.name || '') : null),
        quantity: 1,
        userInteracted: false
    };

    // Sync brand selector tabs
    function renderBrandTabs() {
        if (!els.brandsContainer || !hasModelOption || activeBrands.length === 0) return;
        
        // Update active class on pills
        els.brandsContainer.querySelectorAll('[data-brand-tab]').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.brandTab === state.selectedBrand);
        });
    }

    // Populate model selector dropdown
    function populateModelsDropdown() {
        if (!els.modelSelect || !hasModelOption) return;

        els.modelSelect.querySelectorAll('option').forEach(opt => {
            if (!opt.value) return; // Keep "Model Seçin"
            if (opt.dataset.brand === state.selectedBrand) {
                opt.hidden = false;
                opt.disabled = false;
            } else {
                opt.hidden = true;
                opt.disabled = true;
            }
        });

        els.modelSelect.value = state.selectedModel;
    }

    // Render colors swatch list (uses div elements with cursor:pointer to prevent browser button stretching bugs)
    function renderColors() {
        if (!els.colorsContainer || !hasColorOption) return;

        els.colorsContainer.querySelectorAll('[data-pdp-color-name]').forEach(dot => {
            const colorName = dot.dataset.pdpColorName;
            const isActive = colorName === state.selectedColor;
            dot.classList.toggle('active', isActive);
            const labelEl = dot.querySelector('small');
            if (labelEl) {
                labelEl.textContent = isActive ? "Seçili" : "Seç";
            }
        });
    }

    // Get color hex values for swatches
    function getColorHex(colorName) {
        const cLower = colorName.toLowerCase();
        
        // Match mock values
        if (cLower.includes('graphite') || cLower.includes('grafit')) return { a: '#EEF0F2', b: '#17191D' };
        if (cLower.includes('moss') || cLower.includes('yeşil')) return { a: '#EAF1EC', b: '#26382D' };
        if (cLower.includes('clay') || cLower.includes('kil')) return { a: '#F6E8DF', b: '#B6513A' };
        if (cLower.includes('ice') || cLower.includes('buz')) return { a: '#FFFFFF', b: '#A8E8FF' };
        if (cLower.includes('smoke') || cLower.includes('duman')) return { a: '#F8FAFA', b: '#727A7C' };
        if (cLower.includes('rose') || cLower.includes('pembe')) return { a: '#FFF7F3', b: '#ED9A8B' };
        if (cLower.includes('forest') || cLower.includes('orman')) return { a: '#DCE7D8', b: '#314535' };
        if (cLower.includes('stone') || cLower.includes('taş')) return { a: '#F2F0EC', b: '#8B8178' };
        if (cLower.includes('ink') || cLower.includes('mürekkep') || cLower.includes('siyah')) return { a: '#D7D9DB', b: '#151716' };
        if (cLower.includes('ivory') || cLower.includes('fildişi')) return { a: '#FAF4E8', b: '#1E1E1B' };
        if (cLower.includes('blue') || cLower.includes('mavi')) return { a: '#E7F0FF', b: '#1769FF' };
        if (cLower.includes('volt') || cLower.includes('sarı')) return { a: '#F6FFE2', b: '#B9FF38' };
        if (cLower.includes('lilac') || cLower.includes('eflatun')) return { a: '#F1E7FF', b: '#8A6DCC' };
        if (cLower.includes('sage') || cLower.includes('adaçayı')) return { a: '#EEF4E9', b: '#8EA37F' };
        if (cLower.includes('sand') || cLower.includes('kum')) return { a: '#F8F1E7', b: '#B89A6F' };
        if (cLower.includes('crystal') || cLower.includes('şeffaf')) return { a: '#FFFFFF', b: '#D8F7FF' };
        
        return { a: '#FFFFFF', b: '#888888' };
    }

    // Find selected variant
    function getSelectedVariant() {
        return variants.find(v => {
            let matches = true;
            if (hasModelOption && v[modelPropName] !== state.selectedModel) matches = false;
            if (hasColorOption && v[colorPropName] !== state.selectedColor) matches = false;
            if (hasBrandOption) {
                const vBrand = (v[brandPropName] || "").toLowerCase();
                const selBrand = (state.selectedBrand || "").toLowerCase();
                const isIphone = selBrand.includes('iphone') || selBrand.includes('apple');
                const isSamsung = selBrand.includes('samsung') || selBrand.includes('galaxy');
                
                if (isIphone && !vBrand.includes('iphone') && !vBrand.includes('apple')) matches = false;
                else if (isSamsung && !vBrand.includes('samsung') && !vBrand.includes('galaxy')) matches = false;
                else if (!isIphone && !isSamsung && selBrand !== 'other' && !vBrand.includes(selBrand)) matches = false;
            }
            return matches;
        });
    }

    // Update prices, photos, forms and dynamic notifications based on selections
    function updateVariantState() {
        const variant = getSelectedVariant();
        
        // Build dynamic selection text
        let selectionParts = [];
        if (hasModelOption) selectionParts.push(state.selectedModel || "Model Seçin");
        if (hasColorOption) selectionParts.push(state.selectedColor || "Renk Seçin");
        const optionText = selectionParts.join(" / ") || "Seçenek Seçin";

        // Update labels
        if (els.deviceSummary) els.deviceSummary.textContent = optionText;
        if (els.currentBrand && hasModelOption) els.currentBrand.textContent = state.selectedBrand.toUpperCase();
        if (els.currentModel && hasModelOption) els.currentModel.textContent = state.selectedModel || "Model Seçin";
        if (els.decisionColor && hasColorOption) els.decisionColor.textContent = state.selectedColor;

        if (els.stickySelection) els.stickySelection.textContent = optionText;

        // Scarcity text
        if (hasColorOption && state.selectedColor) {
            if (els.inventoryTitle) els.inventoryTitle.textContent = `${state.selectedColor} rengi bugün hızlı ilerliyor.`;
            if (els.inventoryCopy) {
                const seed = Math.abs(state.selectedColor.charCodeAt(0) - 65) % 10;
                els.inventoryCopy.textContent = `Son 1 saatte ${18 + seed * 4} adet sepete eklendi.`;
            }
        }

        if (variant) {
            // Update Prices
            if (els.price) els.price.textContent = formatMoney(variant.price);
            if (els.compare) {
                const compPrice = (variant.compare_at_price && variant.compare_at_price > variant.price) ? variant.compare_at_price : Math.ceil(variant.price * 1.18);
                if (compPrice > variant.price) {
                    els.compare.textContent = formatMoney(compPrice);
                    els.compare.hidden = false;
                } else {
                    els.compare.hidden = true;
                }
            }

            // Sync Sticky Buy pricing
            if (els.stickyPrice) {
                const compPrice = (variant.compare_at_price && variant.compare_at_price > variant.price) ? variant.compare_at_price : Math.ceil(variant.price * 1.18);
                const oldPriceHtml = compPrice > variant.price 
                    ? `<span class="compare-price" style="text-decoration:line-through; font-size:12px; color:var(--text-muted); margin-right:8px;">${formatMoney(compPrice)}</span>` 
                    : '';
                els.stickyPrice.innerHTML = `${oldPriceHtml}<span class="current-price" style="font-weight:800; color:var(--text-obsidian);">${formatMoney(variant.price)}</span>`;
            }

            // Update Image
            if (variant.featured_image?.src && els.mainImage) {
                els.mainImage.src = variant.featured_image.src;
            }

            // Update Add to Cart Button state
            if (variant.available) {
                if (els.addBtn) {
                    els.addBtn.disabled = false;
                    els.addBtn.textContent = "Sepete Ekle";
                }
                if (els.stickyAdd) {
                    els.stickyAdd.disabled = false;
                    els.stickyAdd.textContent = "SEPETE EKLE";
                }
            } else {
                if (els.addBtn) {
                    els.addBtn.disabled = true;
                    els.addBtn.textContent = "Tükendi";
                }
                if (els.stickyAdd) {
                    els.stickyAdd.disabled = true;
                    els.stickyAdd.textContent = "TÜKENDİ";
                }
            }
        } else {
            // Options not fully selected yet
            let btnText = "Model Seçin";
            if (hasModelOption && !state.selectedModel) {
                btnText = "Model Seçin";
            } else if (hasColorOption && !state.selectedColor) {
                btnText = "Renk Seçin";
            } else {
                btnText = "Seçim Yapın";
            }
            
            if (els.addBtn) {
                els.addBtn.disabled = true;
                els.addBtn.textContent = btnText;
            }
            if (els.stickyAdd) {
                els.stickyAdd.disabled = true;
                els.stickyAdd.textContent = btnText.toUpperCase();
            }
        }

        updateStickyBarVisibility();
    }

    // Scroll Sticky bar logic
    function updateStickyBarVisibility() {
        if (!els.addBtn || !els.stickyBuy) return;
        const addRect = els.addBtn.getBoundingClientRect();
        els.stickyBuy.classList.toggle("visible", addRect.top < 0);
    }

    // Listen to scroll events
    window.addEventListener("scroll", updateStickyBarVisibility, { passive: true });
    window.addEventListener("resize", updateStickyBarVisibility, { passive: true });



    // Set up quantity selectors
    function setupQuantityListeners() {
        document.querySelectorAll('[data-pdp-qty]').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const action = e.currentTarget.dataset.pdpQty;
                if (action === 'plus') {
                    state.quantity = Math.min(10, state.quantity + 1);
                } else if (action === 'minus') {
                    state.quantity = Math.max(1, state.quantity - 1);
                }
                
                if (els.qtyValue) els.qtyValue.textContent = state.quantity;
            });
        });
    }

    // Set up add to cart buttons
    function setupAddToCartListeners() {
        const triggerAdd = () => {
            const variant = getSelectedVariant();
            if (!variant) return;

            // Get customization properties based on visible containers
            const properties = {};
            const textContainer = document.querySelector('.pdp-custom-type-text');
            const imageContainer = document.querySelector('.pdp-custom-type-image');

            if (textContainer) {
                const customText = els.customNote ? els.customNote.value.trim() : '';
                if (!customText) {
                    if (els.customNote) {
                        els.customNote.style.borderColor = 'var(--error, #EF4444)';
                        els.customNote.style.boxShadow = '0 0 0 3px rgba(239, 68, 68, 0.2)';
                        els.customNote.focus();
                    }
                    
                    let warnMsg = textContainer.querySelector('.custom-note-warning');
                    if (!warnMsg) {
                        warnMsg = document.createElement('div');
                        warnMsg.className = 'custom-note-warning';
                        warnMsg.style.color = 'var(--error, #EF4444)';
                        warnMsg.style.fontSize = '12px';
                        warnMsg.style.marginTop = '8px';
                        warnMsg.style.fontWeight = '600';
                        warnMsg.textContent = 'Lütfen kılıf üzerine yazılacak metni girin.';
                        textContainer.appendChild(warnMsg);
                    }
                    return;
                } else {
                    if (els.customNote) {
                        els.customNote.style.borderColor = '';
                        els.customNote.style.boxShadow = '';
                    }
                    const warnMsg = textContainer.querySelector('.custom-note-warning');
                    if (warnMsg) warnMsg.remove();
                    
                    properties['Kişiselleştirme Metni'] = customText;
                    
                    // Add selected text color property
                    const activeColorBtn = document.querySelector('.btn-text-color.active');
                    if (activeColorBtn) {
                        properties['Yazı Rengi'] = activeColorBtn.dataset.color === '#000000' ? 'Siyah' : 'Beyaz';
                    }
                }
            } else if (imageContainer) {
                const fileInput = document.getElementById('pdp-custom-image-file');
                if (!fileInput || !fileInput.files || !fileInput.files[0]) {
                    const uploadWrapper = document.querySelector('.pdp-image-upload-wrapper');
                    if (uploadWrapper) {
                        uploadWrapper.style.borderColor = 'var(--error, #EF4444)';
                        uploadWrapper.style.boxShadow = '0 0 0 3px rgba(239, 68, 68, 0.2)';
                    }
                    alert('Lütfen yüklenecek resmi seçin.');
                    return;
                } else {
                    const uploadWrapper = document.querySelector('.pdp-image-upload-wrapper');
                    if (uploadWrapper) {
                        uploadWrapper.style.borderColor = '';
                        uploadWrapper.style.boxShadow = '';
                    }
                    properties['Yüklenecek Resim'] = fileInput.files[0];
                }
            }

            // Call universal addToCart function
            if (window.addToCart) {
                window.addToCart(variant.id, state.quantity, properties);
            }
        };

        if (els.addBtn) els.addBtn.addEventListener('click', triggerAdd);
        if (els.stickyAdd) els.stickyAdd.addEventListener('click', triggerAdd);
    }

    // Dropdown change listener
    if (els.modelSelect) {
        els.modelSelect.addEventListener('change', (e) => {
            state.userInteracted = true;
            state.selectedModel = e.target.value;
            if (els.autoNote) els.autoNote.hidden = true; // hide detection note on manual select
            updateVariantState();
        });
    }

    // Live Visitor Scarcity Widget Logic
    function initScarcityWidget() {
        const scarcitySettings = window.pdpScarcitySettings || {
            visitorsMin: 18,
            visitorsMax: 75,
            cartMin: 2,
            cartMax: 12
        };

        const vCountEl = document.getElementById("live-visitors-count");
        const cCountEl = document.getElementById("product-cart-count");

        if (!vCountEl && !cCountEl) return;

        // 1. Active Visitors (Shared/Global across pages in session)
        let activeVisitors = sessionStorage.getItem("divacase_active_visitors");
        if (!activeVisitors) {
            const min = scarcitySettings.visitorsMin;
            const max = scarcitySettings.visitorsMax;
            activeVisitors = Math.floor(Math.random() * (max - min + 1)) + min;
            sessionStorage.setItem("divacase_active_visitors", activeVisitors);
        } else {
            activeVisitors = parseInt(activeVisitors, 10);
        }

        if (vCountEl) vCountEl.textContent = activeVisitors;

        // Simulate real-time fluctuations
        setInterval(() => {
            const min = scarcitySettings.visitorsMin;
            const max = scarcitySettings.visitorsMax;
            let change = 0;
            const rand = Math.random();
            if (rand > 0.6) {
                change = Math.floor(Math.random() * 3); // +1 or +2
            } else if (rand < 0.2) {
                change = -Math.floor(Math.random() * 2); // -1
            }
            
            activeVisitors = Math.max(min, Math.min(max, activeVisitors + change));
            sessionStorage.setItem("divacase_active_visitors", activeVisitors);
            
            if (vCountEl) vCountEl.textContent = activeVisitors;
        }, 8000);

        // 2. Cart Count (Unique to this product, persists for that product in session)
        if (cCountEl) {
            const cacheKey = `divacase_cart_count_${product.id}`;
            let cartCount = sessionStorage.getItem(cacheKey);
            if (!cartCount) {
                const min = scarcitySettings.cartMin;
                const max = scarcitySettings.cartMax;
                cartCount = Math.floor(Math.random() * (max - min + 1)) + min;
                sessionStorage.setItem(cacheKey, cartCount);
            } else {
                cartCount = parseInt(cartCount, 10);
            }
            cCountEl.textContent = cartCount;
        }

        // 3. Sliding Animation (Vertical Switcher)
        const track = document.querySelector(".live-stats-widget .scarcity-track");
        if (track && track.classList.contains('has-both')) {
            let currentSlide = 0;
            setInterval(() => {
                currentSlide = (currentSlide === 0) ? 1 : 0;
                track.style.transform = `translateY(-${currentSlide * 24}px)`;
            }, 4000);
        }
    }

    // Initialize all components
    if (els.brandsContainer && hasModelOption) {
        els.brandsContainer.querySelectorAll('[data-brand-tab]').forEach(tab => {
            tab.addEventListener('click', (e) => {
                state.userInteracted = true;
                const brand = e.currentTarget.dataset.brandTab;
                state.selectedBrand = brand;
                state.selectedModel = ''; // reset model
                renderBrandTabs();
                populateModelsDropdown();
                updateVariantState();
            });
        });
    }

    if (els.colorsContainer && hasColorOption) {
        els.colorsContainer.querySelectorAll('[data-pdp-color-name]').forEach(dot => {
            dot.addEventListener('click', (e) => {
                state.userInteracted = true;
                const colorName = e.currentTarget.dataset.pdpColorName;
                state.selectedColor = colorName;
                renderColors();
                updateVariantState();
            });
            dot.addEventListener('keydown', (e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    e.currentTarget.click();
                }
            });
        });
    }

    if (els.customNote) {
        els.customNote.addEventListener('input', () => {
            els.customNote.style.borderColor = '';
            els.customNote.style.boxShadow = '';
            const warnMsg = els.customNote.parentElement.querySelector('.custom-note-warning');
            if (warnMsg) warnMsg.remove();
        });

        // Bind text color buttons click events
        document.querySelectorAll('.btn-text-color').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const targetBtn = e.currentTarget;
                targetBtn.parentElement.querySelectorAll('.btn-text-color').forEach(b => {
                    b.style.borderColor = 'transparent';
                    b.classList.remove('active');
                });
                targetBtn.style.borderColor = 'var(--text-obsidian)';
                targetBtn.classList.add('active');
            });
        });
    }

    // File input upload selection listener (placed outside customNote block)
    const fileInput = document.getElementById('pdp-custom-image-file');
    const uploadWrapper = document.querySelector('.pdp-image-upload-wrapper');
    if (fileInput && uploadWrapper) {
        fileInput.addEventListener('change', () => {
            const label = uploadWrapper.querySelector('.upload-label');
            const filename = uploadWrapper.querySelector('.upload-filename');
            
            if (fileInput.files && fileInput.files[0]) {
                const file = fileInput.files[0];
                if (label) label.style.display = 'none';
                if (filename) {
                    filename.textContent = `Seçilen Dosya: ${file.name}`;
                    filename.style.display = 'block';
                }
                uploadWrapper.style.borderColor = 'var(--accent-cobalt)';
                uploadWrapper.style.background = 'rgba(0,122,255,0.02)';
            } else {
                if (label) label.style.display = 'block';
                if (filename) filename.style.display = 'none';
                uploadWrapper.style.borderColor = 'rgba(0,0,0,0.08)';
                uploadWrapper.style.background = 'var(--bg-surface)';
            }
        });
    }

    renderBrandTabs();
    populateModelsDropdown();
    renderColors();
    setupQuantityListeners();
    setupAddToCartListeners();
    updateVariantState();
    initScarcityWidget();

})();
